import loadable from '@wix/yoshi-flow-editor/loadable';

export const AboutPage = loadable(
  () => import(/* webpackChunkName: "AboutPage" */ './AboutPage'),
  {
    resolveComponent: (component) => component.AboutPage,
  },
);
